export enum PdfCellType {
    TEXT,
    NUMBER,
    DATE,
    HEADER
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/pdf/pdf-cell-type.enum.ts